export default () => {
    return {
        tooltip: {
            enabled: false,
        },
    };
};
